import React from 'react';
import PropTypes from 'prop-types';
import Visibility from 'material-ui/svg-icons/action/visibility';
import './lineJurisdiction.scss';
import ArrowExpandButton from '../arrowExpandButton/ArrowExpandButton';

class LineJurisdiction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: !props.invoiceDetail.jurisdictionItems.length
    };
  }

  handleExpand = () => this.setState({ collapsed: false });

  handleCollapse = () => this.setState({ collapsed: true });

  render() {
    const { totalTaxRate, totalTaxAmount, jurisdictionItems } = this.props.invoiceDetail;
    const { collapsed } = this.state;
    return (
      <div className="line-jurisdiction">
        {
          jurisdictionItems.length > 1 &&
          <div className="line-jurisdiction__arrow-expander">
            <ArrowExpandButton
              collapsed={ collapsed }
              onExpand={ this.handleExpand }
              onCollapse={ this.handleCollapse }
            />
          </div>
        }
        <div className="line-jurisdiction__grid-container">
          <div className="line-jurisdiction__columns-row">
            <div className="line-jurisdiction__column">Jurisdiction</div>
            <div className="line-jurisdiction__column_fixed-small">Total Rate</div>
            <div className="line-jurisdiction__column_fixed">Taxable</div>
            <div className="line-jurisdiction__column_fixed">Exempt</div>
            <div className="line-jurisdiction__column_fixed">Tax Amount</div>
            <div className="line-jurisdiction__column_fixed"/>
          </div>
          <hr />
          {
            !collapsed &&
              <React.Fragment>
                {
                  jurisdictionItems.map(({ jurisdictionType, jurisdiction, taxAmount, taxRate, taxable, exempt }, index) => (
                    <div className="line-jurisdiction__row" key={ `${ jurisdictionType}-${ index }` }>
                      <div className="line-jurisdiction__column">
                        <span className="jurisdiction-type">{`${ jurisdictionType }:`}</span>{ jurisdiction }
                      </div>
                      <div className="line-jurisdiction__column_fixed-small">{ parseFloat(parseFloat(taxRate).toFixed(5)).toString() }</div>
                      <div className="line-jurisdiction__column_fixed">{ taxable }</div>
                      <div className="line-jurisdiction__column_fixed">{ exempt }</div>
                      <div className="line-jurisdiction__column_fixed">{ taxAmount }</div>
                      <div className="line-jurisdiction__column_fixed">
                        { 
                          (index === 0 && jurisdiction !== 'None') && 
                          <Visibility style={ { color: '#000', height: 20, width: 20, cursor: 'pointer' } } /> 
                        }
                      </div>
                    </div>
                  ))
                }
                { jurisdictionItems.length > 1 && <hr /> }
              </React.Fragment>
          }
          {
            jurisdictionItems.length > 1 &&
            <div className="line-jurisdiction__row line-jurisdiction__row_bold">
              <div className="line-jurisdiction__column">
                <span className="jurisdiction-type">{ collapsed ? 'State: ' : 'Totals' }</span>
                { collapsed ? jurisdictionItems.find(jurisdiction => jurisdiction.jurisdictionType === 'State').jurisdiction : '' }
              </div>
              <div className="line-jurisdiction__column_fixed-small">{ parseFloat(parseFloat(totalTaxRate).toFixed(5)).toString() }</div>
              <div className="line-jurisdiction__column_fixed line-jurisdiction__column_light">{ collapsed ? 'Expand for Detail' : '' }</div>
              <div className="line-jurisdiction__column_fixed line-jurisdiction__column_light">{ collapsed ? 'Expand for Detail' : '' }</div>
              <div className="line-jurisdiction__column_fixed">{ totalTaxAmount }</div>
              <div className="line-jurisdiction__column_fixed">
                { 
                  collapsed && 
                  <Visibility style={ { color: '#000', height: 20, width: 20, cursor: 'pointer' } } /> 
                }
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

LineJurisdiction.propTypes = {
  invoiceDetail: PropTypes.object.isRequired
};

export default LineJurisdiction;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/lineJurisdiction/LineJurisdiction.js